import type React from 'react';
import { useState } from 'react';

import { useProfileModeration } from 'hooks/useProfileModeration';
import { useGetCurrentProfile } from '../model/services';

import { StudentProfileChanges } from './StudentProfileChanges';
import { StudentProfileEdit } from './StudentProfileEdit';
import { StudentProfilePending } from './StudentProfilePending';
import { StudentProfileView } from './StudentProfileView';
import { studentProfileScreen } from './studentProfileScreen';

export const ProfileMain: React.FC = () => {
  const { data: currentProfile } = useGetCurrentProfile();
  const { status, comment } = useProfileModeration();
  const [editing, setEditing] = useState(false);
  const [peekView, setPeekView] = useState(false);

  const screen = studentProfileScreen(status, editing, peekView);

  if (!currentProfile) {
    return null;
  }

  if (screen === 'edit') {
    return (
      <StudentProfileEdit
        onCancel={() => {
          setEditing(false);
          setPeekView(false);
        }}
      />
    );
  }

  if (screen === 'changes') {
    return (
      <StudentProfileChanges
        profile={currentProfile}
        comment={comment}
        onFix={() => setEditing(true)}
      />
    );
  }

  if (screen === 'pending') {
    return (
      <StudentProfilePending
        profile={currentProfile}
        onView={() => setPeekView(true)}
      />
    );
  }

  return (
    <StudentProfileView
      profile={currentProfile}
      onEdit={() => setEditing(true)}
    />
  );
};
